import homepage from '../content/homepage.json';

export function BrandLogo() {
  const mask = `url("${homepage.brand.logo}")`;
  return <>
    <span className="brand-logo" role="img" aria-label="SUiiLife" style={{ maskImage: mask, WebkitMaskImage: mask }} />
    <span className="brand-tagline">{homepage.brand.tagline}</span>
  </>;
}
